import { AnyAction } from 'redux'
import actionTypes from '../actions/actionTypes'

const defaultState = {
	activities: [],
}

function updateActivities(state: any, action: AnyAction) {
	return {
		...state,
		activities: action.activities,
	}
}

function qsReducer(state: any = defaultState, action: AnyAction): any {
	switch (action.type) {
		case actionTypes.PREVIEW_DATA_SUCCESS:
			return updateActivities(state, action)
		default:
			return state
	}
}

export default qsReducer
